export const SET_PROMOTE_TIER_UPGRADE_MODAL_IS_VISIBLE =
  'SET_PROMOTE_TIER_UPGRADE_MODAL_IS_VISIBLE';
export const GET_ORDER_TYPES_LIST = 'GET_ORDER_TYPES_LIST';
export const GET_TAX_CATEGORY_LIST_SUCCESS = 'GET_TAX_CATEGORY_LIST_SUCCESS';

export const GET_LANGUAGES_CONFIG_SUCCESS = 'GET_LANGUAGES_CONFIG_SUCCESS';
export const GET_MISSING_POS_MAPPINGS_SUCCESS =
  'GET_MISSING_POS_MAPPINGS_SUCCESS';
